import React from 'react';

const getCountDown = (toDate) => {
  const countDownDate = new Date(toDate).getTime();
  const now = new Date().getTime();
  const distance = countDownDate - now;
  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  return { days, hours, minutes };
};
const countDown = getCountDown('June 27, 2019 15:30:00');
const CoupleSection = () => (
  <section id="the-couple" className="bg-white section-divider section-divider-y">
    <div className="container">
      <div className="row justify-content-center mb-5">
        <div className="col-lg-7 mb-md-5 text-center">
          <i className="flaticon flaticon-001-bride-1 icon-medium text-base-color" />
          <h3 className="font-alt letter-spacing-1 m-0 mt-1 text-uppercase title-small">The Happy Couple</h3>
          <span className="font-alt2 d-block mt-1 text-gray-700 text-large">A happy marriage is the union of two good forgivers.</span>
          <span className="bg-base-color d-block mt-3 mx-auto sep-line-thick-long" />
        </div>

      </div>


      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-3">
          <div className="align-items-center d-flex h-100">
            <div className="text-center text-md-left">
              <span className="d-block font-alt letter-spacing-1 text-extra-large text-uppercase">Melissa Vazquez</span>
              <span className="d-block font-alt2 text-gray-700 text-medium">I kind of have a thing for Him</span>
              <span className="bg-base-color mt-3 mx-auto mx-md-0 sep-line-thick" />
              <p className="mb-0 mt-3 text-medium">The term love at first sight was a real experience for me. I literally called “dibs” the moment I set eyes on him walking up the stairs at a friends house. Six years later we are not only planning a wedding but a future for the rest of our lives. I couldn’t be any happier and can’t wait to celebrate with all my loved ones.</p>
            </div>

          </div>

        </div>


        <div className="col-md-6 col-lg-3 mt-4 mt-md-0 order-md-first">
          <div className="bg-white border border-gray-200 box-shadow p-2 position-relative">
            <img src="./img/mexico/melissa_beach.jpg" alt="" className="img-fluid" />

            <div className="bg-base-color bottom-0 box-shadow-shallow m-3 opacity-9-5 position-absolute px-3 py-2 right-0 rounded">
              <span className="font-alt2 text-small text-white">The Bride</span>
            </div>

          </div>

        </div>


        <div className="col-md-6 col-lg-3 mt-5 mt-lg-0 order-md-12">
          <div className="align-items-center d-flex h-100">
            <div className="text-center text-md-left">
              <span className="d-block font-alt letter-spacing-1 text-extra-large text-uppercase">Arturo Montoya</span>
              <span className="d-block font-alt2 text-gray-700 text-medium">I kind of have a thing for Her</span>
              <span className="bg-base-color mt-3 mx-auto mx-md-0 sep-line-thick" />
              <p className="mb-0 mt-3 text-medium">Melissa means so much to me and I can't believe she is actually going to marry me. I'm so excited to spend the rest of my life with her. Melissa is perfect for me.</p>
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>

          </div>

        </div>


        <div className="col-md-6 col-lg-3 mt-4 mt-md-5 mt-lg-0 order-md-9">
          <div className="bg-white border border-gray-200 box-shadow p-2 position-relative">
            <img src="./img/hawaii/arturo_trees.jpg" alt="" className="img-fluid" />

            <div className="bg-base-color bottom-0 box-shadow-shallow m-3 opacity-9-5 position-absolute px-3 py-2 right-0 rounded">
              <span className="font-alt2 text-small text-white">The Groom</span>
            </div>

          </div>

        </div>

      </div>


      <div className="row justify-content-center mt-5">
        <div className="col-sm-10 col-md-8 mt-5 pt-lg-3 text-center">
          <span className="d-block font-alt letter-spacing-1 text-extra-large text-uppercase">Just Remaining Days..</span>


          <div id="clock" className="row justify-content-center mt-4">
            <div className="col-4 col-sm-3 col-lg-2 border-gray-300 border-right text-center">
              <span className="d-block font-alt letter-spacing-1 text-base-color text-uppercase title-large title-sm-extra-large title-lg-extra-large">{countDown.days}</span>
              <span className="d-block font-alt2 text-gray-700 text-medium text-md-large">Days</span>
            </div>
            <div className="col-4 col-sm-3 col-lg-2 border-gray-300 border-right text-center">
              <span className="d-block font-alt letter-spacing-1 text-base-color text-uppercase title-large title-sm-extra-large title-lg-extra-large">{countDown.hours}</span>
              <span className="d-block font-alt2 text-gray-700 text-medium text-md-large">Hours</span>
            </div>
            <div className="col-4 col-sm-3 col-lg-2 border-gray-300 border-sm-right text-center">
              <span className="d-block font-alt letter-spacing-1 text-base-color text-uppercase title-large title-sm-extra-large title-lg-extra-large">{countDown.minutes}</span>
              <span className="d-block font-alt2 text-gray-700 text-medium text-md-large">Minutes</span>
            </div>
          </div>


          <span className="d-block font-alt2 mt-1 text-gray-700 text-large">Until We Get Married!</span>
        </div>

      </div>

    </div>
  </section>
);
export default CoupleSection;
